import React from 'react';
export class PaginatorItem extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const colorStyle = this.props.selected ? 'text-white bg-primary-600' : 'hover:bg-primary-900';
            return (React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement("button", { onClick: this.props.onClick, className: `mx-0.5 px-3 py-1 rounded-md ${colorStyle} focus:outline-none transition-colors duration-150` }, this.props.index))));
        };
    }
}
